const EVENTS_AR = {
  accepted: "تم قبول العرض من قبل العميل",
  booking_auto_extended: "تمديد تلقائي",
  booking_end: "طلب إنهاء الحجز",
  booking_extension: "طلب تمديد",
  break_repair: "أعطال كبيرة",
  break_repair_2: "أعطال صغيرة",
  breakdown: "عطل",
  breakdown_electric: "عطل كهربائي",
  breakdown_engine: "عطل في المحرك",
  breakdown_mecanic: "عطل ميكانيكي",
  breakdown_other: "عطل آخر",
  canceled: "ملغى",
  closed: "مغلق",
  confirmed: "تم تأكيد الطلب",
  damages_third_parties: "مطالبة قانونية بالتعويض",
  delay_in_delivery: "تأخير في التسليم",
  deliveryOn: "التسليم في",
  document_compliance: "امتثال المستندات",
  events: "{{count}}  أحداث",
  forgetting_extend: "نسيان التمديد",
  forgetting_recover: "نسيان الاسترجاع",
  from_date: "بداية",
  hours_record: "تسجيل الساعات",
  immobilisation: "توقيف",
  incompetent_operator: "مشغل غير كفء",
  inventory: "جرد",
  keys: "مفتاح/رمز: فقدان/لم يتم الإبلاغ",
  machine_delivery: "تسليم",
  machine_retrieval: "استرجاع",
  missing_accessory: "ملحق مفقود",
  n1_control: "فحص N1",
  n2_control: "فحص N2",
  n3_control: "فحص N3",
  no_show: "تسليم: لم يحضر",
  open: "مفتوح",
  openEvents: "أحداث مفتوحة",
  operator_change: "تغيير المشغل",
  other: "أخرى",
  other_delivery: "تسليم آخر",
  other_request: "طلب آخر",
  quality_issue: "معدات بحالة سيئة",
  retrievalOn: "الاسترجاع في",
  robbery_accessory: "سرقة ملحق",
  robbery_article: "سرقة آلة",
  sent: "تم استلام الطلب",
  to_date: "نهاية",
  undeclared_use: "استخدام غير مصرح به",
  validated: "تمت الموافقة على طلب الحجز",
  weather: "طقس سيء",
  wrong_machine: "خطأ في المعدات",
  wrong_reclassification: "اختيار آلة غير صحيح",
} as const;

export default EVENTS_AR;
